import React from "react";
import "../recommendation_indusview_styles/Recommendation_IndustryView_Styles.css";
const NoRecordsFound: React.FC = () => {
  return (
    <div
      className="list-title"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        color: "#6666",
      }}
    >
      No Videos Found
    </div>
  );
};

export { NoRecordsFound, NoTopicsFound };

const NoTopicsFound: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start", // or 'flex-end'
        paddingTop: "230px",
        color: "#6666",
        justifyContent: "center",
        height: "100%",
      }}
      className="list-title"
    >
      No Topics Found
    </div>
  );
};

//export default NoTopicsFound;
